export const TranslationType = {
  asset: 'asset',
} as const;
